import i18n from "../config/i18n";

let env = require(`../env/production.js`);
//let env = require(`../env/development.js`);

export default {
  firebaseConfig: env.firebaseConfig,
  cloudFunctionsBasePath: env.cloudFunctionsBasePath,
  warmUpApiUrl: env.warmUpApiUrl,

  ownScheduleValue: 0,
  ownScheduleValueTherm: 4,

  currentVersion: 2,
  deviceTypes: {
    oval_towel: "oval_towel",
    radiator: "radiator",
    radiatorb: "radiatorb",
    towel: "towel",
    acs: "acs",
    floor: "floor",
    unknown: "unknow",
    therm: "therm",
  },

  iconOptions: {
    acs: {
      windowsOpenMode: false,
      pirMode: false,
      block: true,
      pilotMode: true,
      userMode: true,
    },

    therm: {
      windowsOpenMode: true,
      pirMode: false,
      block: true,
      pilotMode: false,
      userMode: false,
    },

    towel: {
      windowsOpenMode: true,
      pirMode: true,
      block: true,
      pilotMode: true,
      userMode: true,
    },

    radiator: {
      windowsOpenMode: true,
      pirMode: true,
      block: true,
      pilotMode: true,
      userMode: true,
    },

    radiatorb: {
      windowsOpenMode: true,
      pirMode: true,
      block: true,
      pilotMode: true,
      userMode: true,
    },

    oval_towel: {
      windowsOpenMode: true,
      pirMode: true,
      block: true,
      pilotMode: true,
      userMode: true,
      statusWarming: true,
    },
  },

  status: {
    ice: "ice",
    eco: "eco",
    comfort: "comfort",
    none: "none",
  },

  modes: {
    manual: "manual",
    auto: "auto",
  },

  zoneTypes: {
    towel: "towel",
    oval_towel: "oval_towel",
    radiator: "radiator",
    acs: "acs",
    floor: "floor",
    unknown: "unknow",
  },

  ranges: {
    eco: {
      acs: {
        min: 40.0,
        max: 54.5,
      },
      radiator: {
        min: 7.5,
        default: 15.0,
        max: 18.5,
      },
    },

    backlight: {
      oval_towel: {
        step: 10,
        min: 0,
        max: 100,
        converter: {
          val0: 0,
          val1: 1,
          val2: 2,
          val3: 3,
          val4: 4,
          val5: 5,
          val6: 6,
          val7: 7,
          val8: 8,
          val9: 9,
          val10: 10,
          per0: 0,
          per1: 10,
          per2: 20,
          per3: 30,
          per4: 40,
          per5: 50,
          per6: 60,
          per7: 70,
          per8: 80,
          per9: 90,
          per10: 100,
        },
      },

      step: 10,
      min: 0,
      max: 100,
      converter: {
        val0: 0,
        val1: 1,
        val2: 2,
        val3: 3,
        val4: 4,
        per0: 0,
        per1: 25,
        per2: 50,
        per3: 75,
        per4: 100,
      },
      radiator: {
        step: 25,
        min: 0,
        max: 100,
        converter: {
          val0: 0,
          val1: 1,
          val2: 2,
          val3: 3,
          val4: 4,
          per0: 0,
          per1: 25,
          per2: 50,
          per3: 75,
          per4: 100,
        },
      },

      // step: 1,
      // min: 0,
      // max: 10,

      time: {
        radiator: {
          step: 1,
          min: 0,
          max: 4,
        },
        step: 2,
        min: 10,
        max: 30,
      },

      on: {
        step: 10,
        min: 0,
        max: 100,
        converter: {
          val0: 0,
          val1: 1,
          val2: 2,
          val3: 3,
          val4: 4,
          val5: 5,
          val6: 6,
          val7: 7,
          val8: 8,
          val9: 9,
          val10: 10,
          per0: 0,
          per1: 10,
          per2: 20,
          per3: 30,
          per4: 40,
          per5: 50,
          per6: 60,
          per7: 70,
          per8: 80,
          per9: 90,
          per10: 100,
        },

        radiator: {
          step: 25,
          min: 0,
          max: 100,
        },

        acs: {
          step: 1,
          min: 0,
          max: 10,
        },

        towel: {
          step: 1,
          min: 0,
          max: 10,
        },

        oval_towel: {
          step: 1,
          min: 0,
          max: 10,
        },
      },
    },

    comfort: {
      acs: {
        min: 55,
        max: 73,
      },
      radiator: {
        min: 19,
        max: 30,
      },
    },

    thermostat: {
      acs: {
        min: 40,
        max: 73,
      },
      towel: {
        min: 7,
        max: 30,
      },

      oval_towel: {
        min: 7,
        max: 30,
      },

      radiator: {
        min: 7,
        max: 30,
      },

      floor: {
        min: 7,
        max: 30,
      },

      unknown: {
        min: 7,
        max: 30,
      },

      therm: {
        min: 7,
        max: 30,
      },

      thermFloorProbeOn: {
        min: 7,
        max: 40,
      },
    },
    legionella_conf: {
      min: 0,
      max: 30,
    },

    offset_probe: {
      min: -9.5,
      max: 10,
    },
  },

  months: [
    i18n.t("months.january"),
    i18n.t("months.february"),
    i18n.t("months.march"),
    i18n.t("months.april"),
    i18n.t("months.may"),
    i18n.t("months.june"),
    i18n.t("months.july"),
    i18n.t("months.august"),
    i18n.t("months.september"),
    i18n.t("months.october"),
    i18n.t("months.november"),
    i18n.t("months.december"),
  ],

  //HEAT
  defaultTemp: 20,
  defaultEco: 7.5,
  defaultComfort: 19,
  hotTemp: 24.5,
  iceModeTemp: 7,

  //ACS
  acsDefaultTemp: 60,
  acsDefaultEco: 40.5,
  acsDefaultComfort: 55,
  acsIceModeTemp: 40,
  acsHotTemp: 65.5,

  //SCHEDULE
  defaultProgram: [
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
    "OOOOOOOOOOOOOOOOOOOOOOOO",
  ],

  //TARIFF
  defaultTariff: [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ],

  currency: {
    EUR: "€",
    USD: "$",
    GBP: "£",
    RUB: "₽",
  },

  //STATISTICS
  statisticsModes: {
    daily: 0,
    monthly: 1,
    annual: 2,
  },

  //WARMUP
  refreshInterval: 1000 /*MIL*/ * 60 /*SECONDS*/ * 1 /*MINUTES*/,

  //TOS

  tos: {
    en: "https://www.rointeconnect.com/legal/terms/index-en.html",
    es: "https://www.rointeconnect.com/legal/terms/index-es.html",
    pt: "https://www.rointeconnect.com/legal/terms/index-pt.html",
    fr: "https://www.rointeconnect.com/legal/terms/index-fr.html",
    all: "https://www.rointeconnect.com/legal/terms/app.html"
  },
};
